import Header from "../componentes/header/header";
import Footer from "../componentes/footer/footer";
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './conserto_relogio.css';
import { assets } from "../assets/assets";
import { abrirOrcamentoWhats, trazerRodapePaginasProdutos, trazerTituloProdutos } from "../utils/utils";

const Tabacaria = () => {

  const navigate = useNavigate();
  useEffect(() => {
    document.title = "Trinco | Tabacaria";
  }, []);

  return (
    <div className="servico-detalhe-page">
      <Header />
      {/* Hero Banner */}
      <section className="servico-hero" style={{ backgroundImage: `url(${assets.headerTabacaria})` }}>
        <div className="servico-hero-overlay">
          <h1>Tabacaria</h1>
          {/* <p>Para quem procura por tabacaria</p>*/}
        </div>
      </section>

      {/* Conteúdo Explicativo */}
      <main className="conteudo-servico-container">

        <article className="bloco-texto">
          <h2>{trazerTituloProdutos()}</h2>
        </article>

        {/* Aqui começa todo o conteudo */}
        {/* Seção de Grade de Produtos - Camping e Tabacaria */}
        <section className="acessorios-grid">
          <div className="acessorio-card">
            <div className="acessorio-ilustracao"><img src={assets.fumos} alt="" /></div>
            <h3>Fumo</h3>
            <p>Charutos, tabacos e cachimbos.</p>
          </div>

          <div className="acessorio-card">
            <div className="acessorio-ilustracao"><img src={assets.fogos} alt="" /></div>
            <h3>Fogo</h3>
            <p>Isqueiros, maçaricos, gás e fluido.</p>
          </div>

          <div className="acessorio-card">
            <div className="acessorio-ilustracao"><img src={assets.acessorioFumo} alt="" /></div>
            <h3>Acessórios</h3>
            <p>Piteiras, sedas e dichavadores.</p>
          </div>

        </section>

        {/* Aqui termina todo o conteudo */}

        <div className="fechamento-texto">
          <h4>{trazerRodapePaginasProdutos('tabacaria')}</h4>
        </div>

        {/* CTA FINAL */}
        <div className="cta-container-detalhe">
          <button className="btn-orcamento-whats" onClick={() => abrirOrcamentoWhats('tabacaria')}>
            Solicitar disponibilidade
          </button>
          <button className="btn-voltar-simples" onClick={() => navigate('/')}>
            Voltar para o início
          </button>
        </div>

      </main>
      <Footer />
    </div>
  )
}

export default Tabacaria;